import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';

const styles = {
  enrollmentCard: {
    position: 'relative',
    backgroundColor: colors.neutral.white,
    borderRadius: '1rem',
    padding: '2rem 3.2rem 3.2rem',
    marginBottom: '3.6rem',
    '&:last-of-type': {
      marginBottom: '0',
    },
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    marginBottom: '2rem',
    paddingBottom: '2rem',
    borderBottom: `0.1rem solid ${colors.neutral[300]}`,
  },
  leftHeaderSection: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' },
  rightHeaderSection: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', gap: '2.4rem' },
  effectiveDateTitle: {
    font: { size: '1.6rem', lineHeight: '2.4rem', weight: 500 },
    letterSpacing: '0.02em',
    color: colors.neutral[500],
    textTransform: 'uppercase',
    margin: 0,
    marginBottom: '0.5rem',
  },
  effectiveDateValue: {
    font: {
      size: '2.4rem',
      lineHeight: '3.2rem',
      weight: 700,
    },
    letterSpacing: '0.02em',
    margin: 0,
    color: colors.neutral[900],
    minWidth: '13.2rem',
    marginRight: '2rem',
  },

  stageTagContainer: {
    paddingBottom: '0.3rem',
  },
  footer: {
    display: 'flex',
    flexDirection: 'column',
  },
  portfoliosList: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '3rem',
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
